import global$1 from './global.js';
import isCallable$1 from './is-callable.js';

var global = global$1;
var isCallable = isCallable$1;
var String = global.String;
var TypeError = global.TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};

export { aPossiblePrototype as default };
